import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ActionsComponent} from "./actions.component";
import {
  CollapseModule,
  MDBBootstrapModule,
  MdProgressSpinnerModule,
  NavbarModule,
  TooltipModule,
  WavesModule,
} from "ng-uikit-pro-standard";
import {TranslateModule} from "@ngx-translate/core";
import {ActionsRoutingModule} from "./actions-routing.module";
import {ActionsResource} from "./repository/actions-resource.service";
import {ActionsPerBuildingService} from "./repository/actions-per-building.service";
import {BuildingDetailsService} from "../../buildings/details/building-details.service";
import {InterventionTeamService} from "../../buildings/service/inspection-team.service";
import {DraggableActionComponent} from "./draggable-action/draggable-action.component";
import {ActionStatusIconComponent} from "./status/action-status-icon/action-status-icon.component";
import {BuildingActionsBoardComponent} from "./building-actions-board/building-actions-board.component";
import {AngularSvgIconModule} from "angular-svg-icon";
import {FormsModule} from "@angular/forms";
import {ActionIconComponent} from "./action-icon/action-icon.component";
import {CommonsModule} from "../../common/common.module";
import {ActionContextualMenuComponent} from "./interaction/action-contextual-menu/action-contextual-menu.component";
import {ExecutorsService} from "../../executors/executors.service";
import {BuildingIssuesService} from "../../buildings/issues/building-issues.service";
import {BuildingJobsService} from "../../buildings/issues/building-jobs.service";
import {ActionAssignBoardComponent} from "./assign-board/action-assign-board.component";
import {BuildingComponentsModule} from "../../buildings/components/building-components.module";
import {ChappsCommonAngularLibraryModule, ChappsListModule} from "@npm.chapps.com/chapps.common.angular.library";
import {AssignBoardControlsComponent} from "./assign-board/assign-board-controls/assign-board-controls.component";
import {ActionBusinessRulesService} from "./business-rules/action-business-rules.service";
import {DragDropModule} from "@angular/cdk/drag-drop";
import {ActionsListModule} from "./actions-list/actions-list.module";
import {
  AssignBoardFiltersComponent,
} from './assign-board/assign-board-filters/assign-board-filters/assign-board-filters.component';
import {TeamOverviewComponent} from './team-overview/team-overview.component';
import {DropdownSelectionModule} from "../../common/components/dropdown-selection/dropdown-selection.module";
import {
  StatusContextualMenuComponent,
} from "../../common/ui-components/app-status-contextual-menu/status-contextual-menu.component";
import {MatMenuModule} from '@angular/material/menu';
import {InterventionTeamCardComponent} from './intervention-team-card/intervention-team-card.component';
import {ActionDetailComponent} from './action-detail/action-detail.component';


@NgModule({
  declarations: [
    ActionsComponent,
    ActionStatusIconComponent,
    BuildingActionsBoardComponent,
    DraggableActionComponent,
    ActionIconComponent,
    ActionContextualMenuComponent,
    ActionAssignBoardComponent,
    AssignBoardControlsComponent,
    AssignBoardFiltersComponent,
    TeamOverviewComponent,
    StatusContextualMenuComponent,
    InterventionTeamCardComponent,
    ActionDetailComponent,
  ],
  imports: [
    CommonModule,
    CommonsModule,
    NavbarModule,
    TranslateModule,
    MDBBootstrapModule,
    // ActionsListModule,
    ActionsRoutingModule,
    AngularSvgIconModule,
    TooltipModule,
    FormsModule,
    MatMenuModule,
    MdProgressSpinnerModule,
    BuildingComponentsModule,
    WavesModule,
    ChappsListModule,
    TooltipModule,
    ChappsCommonAngularLibraryModule,
    DragDropModule,
    ActionsListModule,
    DropdownSelectionModule,
    CollapseModule,
    CollapseModule,
  ],
  providers: [
    ActionsResource,
    ActionsPerBuildingService,
    BuildingDetailsService,
    InterventionTeamService,
    BuildingIssuesService,
    BuildingJobsService,
    ExecutorsService,
    ActionBusinessRulesService,
  ]
})
export class ActionsModule {
}
